import { jsx as o } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "M12.907 3.093A5.42 5.42 0 0 0 9.062 1.5a5.44 5.44 0 0 0-4.34 8.717l-2.614 2.614.449 1.673 3.225-3.226a5.422 5.422 0 0 0 3.279 1.099 5.438 5.438 0 0 0 3.845-9.284h.001Zm-1.06 6.63a3.913 3.913 0 0 1-2.785 1.153 3.913 3.913 0 0 1-2.785-1.153 3.943 3.943 0 0 1 0-5.57A3.913 3.913 0 0 1 9.062 3c1.052 0 2.04.41 2.785 1.154a3.943 3.943 0 0 1 0 5.569Z"
      }
    )
  }
);
export {
  t as Search
};
